import { render } from "./B2BMembers.vue?vue&type=template&id=8ecccdf2&scoped=true"
import script from "./B2BMembers.vue?vue&type=script&lang=js"
export * from "./B2BMembers.vue?vue&type=script&lang=js"

import "./B2BMembers.vue?vue&type=style&index=0&id=8ecccdf2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ecccdf2"]])

export default __exports__